import { Box } from '@mui/material';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const CompanyLogo: React.FC = React.memo(() => {
  const { i18n } = useTranslation();

  // Memoize logo calculation to prevent recalculation on every render
  const logoSrc = useMemo(() => {
    const baseLanguage = i18n.language ? i18n.language.split('-')[0] : 'de';
    return `/logo-${baseLanguage}.png`;
  }, [i18n.language]);

  return (
    <Box sx={{ 
      p: 2, 
      display: 'flex', 
      justifyContent: 'center', 
      backgroundColor: 'white',
      borderBottom: '1px solid #C9C9C9'
    }}>
      <a 
        href="https://www.cpro-ips.com" 
        target="_blank" 
        rel="noopener noreferrer"
        style={{ display: 'block', textAlign: 'center' }}
      >
        <img 
          src={logoSrc} 
          alt="CPRO IPS" 
          style={{ 
            height: '40px',
            maxWidth: '100%',
            objectFit: 'contain'
          }} 
        />
      </a>
    </Box>
  );
});